/**
 * Created by Timur on 21.08.2026
 */

(function () {
    const original = MissionsTool.getMissionMenu;

    const listAllItems = function () {
        const items = [];

        Merge2MissionFamilies.getGroups().forEach((group) => {
            Merge2MissionFamilies.getGroupItems(group).forEach((item) => items.push(item));
        });

        return items;
    };

    const discoverItem = function (library, item) {
        library.discovered[item.code] = library.discovered[item.code] || {};
        library.discovered[item.code][item.stage] = true;

        library.unclaimed[item.code] = library.unclaimed[item.code] || {};
        library.unclaimed[item.code][item.stage] = true;
    };

    const listSpawnableItems = function () {
        const config = Merge2MissionFamilies.getConfig();
        const items = [];

        Object.keys(config).forEach((code) => {
            Merge2MissionFamilies.getStages(code).forEach((stage) => {
                if (Merge2MissionFamilies.getStageConfig(code, stage).type !== Merge2MissionFamilies.TYPE.GOAL) {
                    items.push({ code, stage });
                }
            });
        });

        return items;
    };

    const findPresentedStage = function () {
        return Merge2MissionFamilies.getConfig()[Merge2MissionFamilies.MAIN].presentationFromStage;
    };

    MissionsTool.getMissionMenu = function (mission) {
        const actions = original.call(this, mission);
        if (mission.type !== Mission.TYPE_MERGE2_MISSION) {
            return actions;
        }

        const logic = () => mission.logic;

        actions.openStartWindow = displayToolWindow(() => new Merge2MissionStartWindow(mission));
        actions.openWindow = displayToolWindow(() => new Merge2MissionWindow(mission));
        actions.openLibraryWindow = displayToolWindow(() => new Merge2MissionUnitsLibraryWindow(mission));
        actions.openVipPassWindow = displayToolWindow(() => new Merge2MissionVipPassWindow(mission));

        actions.showNewItem = () => {
            logic().library.newUnits.push({ code: Merge2MissionFamilies.MAIN, stage: findPresentedStage() });
            logic().update();
        };

        actions.showMainGoal = () => logic().trigger("mainGoalCompleted");

        actions.startTutorial = displayToolWindow(() => {
            if (!logic() || !logic().isRunning()) {
                return;
            }

            if (cleverapps.tutorial.isActive()) {
                cleverapps.tutorial.stop();
            }

            cleverapps.forces.clearForce(Forces.MERGE2_MISSION);

            if (logic().bubblesStack.isEmpty()) {
                logic().bubblesStack.fill();
            }

            new Merge2MissionWindow(mission);
        });

        const setTimeLeft = (interval) => MissionsTool.setTimeLeft(mission, cleverapps.parseInterval(interval));

        actions.setTimeLeftTwoDays = () => setTimeLeft("2 days");
        actions.setTimeLeftOneDay = () => setTimeLeft("1 day");
        actions.setTimeLeftThreeHours = () => setTimeLeft("3 hours");
        actions.setTimeLeftOneHour = () => setTimeLeft("1 hour");

        actions.discoverAllUnits = () => {
            const library = logic().library;

            listAllItems().forEach((item) => discoverItem(library, item));
            library.activations = Merge2MissionUnitsLibrary.getActivationsTotal();

            logic().update();
        };

        actions.discoverAllUnitsButLast = () => {
            const library = logic().library;
            const items = listAllItems();

            items.slice(0, items.length - 1).forEach((item) => discoverItem(library, item));
            library.activations = Merge2MissionUnitsLibrary.getActivationsTotal();

            logic().update();
        };

        actions.resetLibrary = () => {
            const library = logic().library;

            library.discovered = {};
            library.unclaimed = {};
            library.activations = 0;
            library.groupRewarded = {};
            library.libraryRewarded = false;
            library.newUnits = [];

            logic().update();
        };

        actions.resetBubblesStack = () => {
            const bubblesStack = logic().bubblesStack;

            bubblesStack.stack = [];
            bubblesStack.fill();

            logic().update();
        };

        actions.fillBubblesStackWithRandomItems = () => {
            const bubblesStack = logic().bubblesStack;
            const items = listSpawnableItems();

            for (let i = 0; i < 5; i++) {
                const item = items[Math.floor(Math.random() * items.length)];
                bubblesStack.push(item.code, item.stage);
            }

            logic().update();
        };

        actions.unlockVipPass = () => logic().unlockVipPass();

        actions.lockVipPass = () => {
            const vipPass = logic().vipPass;

            vipPass.vip = false;
            vipPass.claimedVip = 0;

            logic().update();
        };

        actions.resetClaimedStages = () => {
            const vipPass = logic().vipPass;

            vipPass.claimed = 0;
            vipPass.claimedVip = 0;

            logic().update();
        };

        actions.fillField = () => {
            const field = logic().field;

            field.eachVisibleCell((x, y) => {
                if (!field.isEmpty(x, y)) {
                    return;
                }

                const roll = Math.random();
                if (roll < 0.1) {
                    return;
                }

                field.addUnit(x, y, field.createUnit(roll < 0.55 ? "M" : "G", 1));
            });

            logic().update();
        };

        actions.shiftFieldTwoRows = () => {
            logic().shiftField(2);
            logic().update();
        };

        actions.shiftFieldFourRows = () => {
            logic().shiftField(4);
            logic().update();
        };

        return actions;
    };
}());
